<template>
    <div class="dashboard cust-drivers cust-drivers--inspection">
        <h1 class="l-mb10">日別車両点検（車両ID {{ id }}）</h1>
        <h2>車両の周り</h2>
        <h3>灯火装置・方向指示器</h3>
        <div class="l-mb8">
            <input id="lighting_or_blinking" v-model="input.lighting_or_blinking" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="lighting_or_blinking">点灯又は点滅具合、汚れ・損傷</label>
        </div>
        <h3>タイヤ</h3>
        <div>
            <input id="tire_disc_wheel_installation" v-model="input.tire_disc_wheel_installation" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="tire_disc_wheel_installation">ディスク・ホイールの取付</label>
        </div>
        <div class="l-mt2">
            <input id="tire_air_pressure" v-model="input.tire_air_pressure" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="tire_air_pressure">空気圧</label>
        </div>
        <div class="l-mt2">
            <input id="tire_crack_damage" v-model="input.tire_crack_damage" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="tire_crack_damage">亀裂・損傷</label>
        </div>
        <div class="l-mt2 l-mb8">
            <input id="tire_abnormal_wear" v-model="input.tire_abnormal_wear" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="tire_abnormal_wear">異常摩耗</label>
        </div>
        <h3>エア・タンク</h3>
        <div class="l-mb8">
            <input id="water_condensation" v-model="input.water_condensation" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="water_condensation">凝水</label>
        </div>
        <h3>積載</h3>
        <div class="l-mb8">
            <input id="agitator_internal_deposits" v-model="input.agitator_internal_deposits" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="agitator_internal_deposits">アジテータ内部の付着物</label>
        </div>
        <h2>運転席</h2>
        <h3>ブレーキ</h3>
        <div>
            <input id="brake_stepping_on_and_effectiveness" v-model="input.brake_stepping_on_and_effectiveness" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="brake_stepping_on_and_effectiveness">踏みしろ及び効き</label>
        </div>
        <div class="l-mt2">
            <input id="brake_amount_of_brake_fluid" v-model="input.brake_amount_of_brake_fluid" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="brake_amount_of_brake_fluid">ブレーキ液の量</label>
        </div>
        <div class="l-mt2">
            <input id="brake_air_pressure" v-model="input.brake_air_pressure" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="brake_air_pressure">空気圧力</label>
        </div>
        <div class="l-mt2">
            <input id="brake_exhaust_sound_from_the_valve" v-model="input.brake_exhaust_sound_from_the_valve" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="brake_exhaust_sound_from_the_valve">バルブからの排気音</label>
        </div>
        <div class="l-mt2 l-mb8">
            <input id="brake_parking_brake_lever_pull" v-model="input.brake_parking_brake_lever_pull" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="brake_parking_brake_lever_pull">駐車ブレーキ・レバーの引きしろ</label>
        </div>
        <h3>原動機</h3>
        <div class="l-mb8">
            <input id="maintenance_flag" v-model="input.depth_abnormal_noise" :type="inputType" :true-value="valueTrue" :false-value="valueFalse">
            <label :class="classCheckboxStyle" for="maintenance_flag">かかり具合・異音</label>
        </div>
        <h2>走行距離入力</h2>
        <div class="l-mb10">
            <input v-model="input.mileage" type="number" max="9999999999" min="0" placeholder="走行距離を数字で入力してください">
        </div>
        <div class="is-center">
            <button :class="`${classButtonStyle}primary`" type="button" @click="handleCreate()">点検完了</button>
            <!-- <button v-if="checkedInput" :class="`${classButtonStyle}primary`" type="button" @click="handleCreate()">点検完了</button>
            <button v-else :class="`${classButtonStyle}cancel`" type="button">点検完了</button> -->
        </div>
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "required": true,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "classCheckboxStyle": "button--ghost",
                "flagButtonCompleted": false,
                "input": {
                    "lighting_or_blinking": "0",
                    "tire_disc_wheel_installation": "0",
                    "tire_air_pressure": "0",
                    "tire_crack_damage": "0",
                    "tire_abnormal_wear": "0",
                    "water_condensation": "0",
                    "agitator_internal_deposits": "0",
                    "brake_stepping_on_and_effectiveness": "0",
                    "brake_amount_of_brake_fluid": "0",
                    "brake_air_pressure": "0",
                    "brake_exhaust_sound_from_the_valve": "0",
                    "brake_parking_brake_lever_pull": "0",
                    "depth_abnormal_noise": "0",
                    "mileage": "",
                },
                "inputType": "checkbox",
                "valueFalse": "0",
                "valueTrue": "1",
            };
        },
        "computed": {
            checkedInput() {
                // チェック項目のバリデーション
                for (let value in this.input) {
                    if (this.input[value] === "0") {
                        this.flagButtonCompleted = false;
                        break;
                    } else {
                        if (this.input.mileage) {
                            this.flagButtonCompleted = true;
                        } else {
                            this.flagButtonCompleted = false;
                            break;
                        }
                    }
                }
                return this.flagButtonCompleted;
            },
        },
        "methods": {
            handleCreate() {
                // 日別車両点検データ作成
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicle_inspection_dates/${this.id}`,
                    this.input,
                    this.$_requestConfig()
                ).then(response => {
                    if (response.data.vehicle_inspection_months === "0") {
                        this.$router.push({ "name": "drivers_vehicle_inspection_months_create", "params": { "id": this.id }});
                    } else if (response.data.vehicle_inspection_months === "1") {
                        this.$router.push({ "name": "drivers_delivery_destinations" });
                    }
                }).catch(() => {
                    alert("日別車両点検の作成に失敗しました。");
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    h2 {
        color: #fff;
    }
    h3 {
        color: #ccc;
    }
</style>
